import React from 'react';

class CartProduct extends React.Component {
  render() {
    return (
      <div />
    );
  }
}

export default CartProduct;
